import { Button, CheckboxField, Modal, TextAreaField } from 'components';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import SelectField from 'components/Forms/SelectField';
import { REGISTERED_TYPE, SANSHO_LEVEL } from 'constant';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { uniqBy } from 'lodash';
import { FC, useCallback, useMemo, useState } from 'react';
import { userService, workerService } from 'services';
import { useSelector } from 'react-redux';
import { layoutSelector } from '../../../containers/Layout/selectors';
import SectionStyled from './styles';
interface Props {}

const EnterInformation: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [dataUser, setDataUser] = useState<{ label: string; value: string | number }[]>([]);
  const { LockStatusData } = useSelector(layoutSelector);
  const [loading, setLoading] = useState(false);

  const getUserHandle = useCallback(async () => {
    setLoading(true);
    userService
      .getUserSites({
        sansho_level: SANSHO_LEVEL.DTC_02_02,
        registered_type: REGISTERED_TYPE.DTC_02_02,
      })
      .then(({ data }) => {
        const dataSelectSite = data.sites.map((item) => ({
          label: item?.site_name,
          value: item?.site_id,
        }));
        if (dataSelectSite) {
          setLoading(false);
          setVisible(true);
          setDataUser(uniqBy(dataSelectSite, 'value'));
        }
      })
      .catch((err) => setLoading(false));
  }, []);

  const initialValues = useMemo(() => {
    const selectName =
      dataUser && dataUser.find((value) => value.label === LockStatusData?.site_name);

    return {
      building_id: (selectName && selectName?.value.toString()) || '',
      content: '',
      push_flag: 0,
    };
  }, [LockStatusData?.site_name, dataUser]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    async onSubmit(values) {
      await workerService.postInformation({
        building_id: Number(values.building_id),
        site_id: Number(values.building_id),
        content: values.content,
        push_flag: +values.push_flag,
      });
      setVisible(false);
      formik.resetForm();
    },
  });

  return (
    <>
      <Button size="small" onClick={() => getUserHandle()} loading={loading}>
        連絡事項入力
      </Button>
      <Modal title="連絡事項入力" visible={visible} footer={false} width={640}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select">
                  <Form.Item
                    className="input-building_id"
                    label="現場"
                    colon={false}
                    name="building_id"
                  >
                    <SelectField
                      data={dataUser}
                      name="building_id"
                      className="select-field"
                      placeholder="現場を選択してください"
                    />
                  </Form.Item>
                  <Form.Item className="input-checkbox" label={<span />} name="push_flag">
                    <CheckboxField name="push_flag">プッシュ通知もあわせて行う</CheckboxField>
                  </Form.Item>
                </div>
                <Form.Item className="note-field" label="内容" name="content" colon={false}>
                  <TextAreaField
                    name="content"
                    className="text-area"
                    placeholder="連絡事項を入力してください"
                    autoSize={{ maxRows: 5 }}
                  />
                </Form.Item>
              </div>
              <div className="ant-modal-footer">
                <Button
                  className="button-secondary"
                  onClick={() => {
                    setVisible(false);
                    formik.resetForm();
                  }}
                >
                  キャンセル
                </Button>
                <ButtonSubmit
                  disabled={
                    !formik.values.building_id ||
                    !formik.values.content ||
                    !(formik.isValid && formik.dirty)
                  }
                >
                  送信
                </ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

export default EnterInformation;

const validationSchema = yup.object().shape({
  building_id: yup.string().required('現場を選択してください。').label('現場'),
  content: yup
    .string()
    .max(1000, '入力可能文字数を超えています。')
    .required('内容を入力してください。')
    .label('内容'),
});
